import React from 'react'
import PropTypes from 'prop-types'
import { useUserSchoolClasses } from '@hooks/useUserSchoolClasses'
import { BOOK_LIST_TYPES, CARD_SIZES } from '@helpers/constants'
import BookList from '@components/BookList'
import Loader from '@components/Loader'
import Text from '@components/Text'

const BooksSharedWithSchoolClassesList = (props) => {
  const { items } = props

  const {
    schoolClasses,
    error: schoolClassesError,
    isLoading: schoolClassesIsLoading,
  } = useUserSchoolClasses()

  // Get array with just user schoolClasses ids for easier comparison
  const userSchoolClassIds =
    schoolClasses && schoolClasses.length > 0
      ? schoolClasses.map((schoolClass) => {
          return schoolClass.id
        }, [])
      : []

  const booksSharedWithSchoolClasses =
    !schoolClassesError && !schoolClassesIsLoading && schoolClasses.length > 0
      ? items.filter((item) => {
          if (!item.schoolClasses.length) return false

          return item.schoolClasses.some((schoolClass) =>
            userSchoolClassIds.includes(schoolClass.id)
          )
        })
      : []

  return (
    <>
      {schoolClassesError && (
        <Text>Någonting gick fel när vi skulle hämta klasser</Text>
      )}
      {!schoolClassesIsLoading && !booksSharedWithSchoolClasses.length && (
        <Text>Klassen har inga böcker ännu.</Text>
      )}
      {!schoolClassesIsLoading && booksSharedWithSchoolClasses.length > 0 && (
        <BookList
          type={BOOK_LIST_TYPES.SHARED}
          gridCols={4}
          items={booksSharedWithSchoolClasses}
          cardSize={CARD_SIZES.SMALL}
          rowLimit={2}
        />
      )}
      {schoolClassesIsLoading && <Loader />}
    </>
  )
}

BooksSharedWithSchoolClassesList.propTypes = {
  items: PropTypes.array,
}

export default BooksSharedWithSchoolClassesList
